<template>
    <div id="stationery-component">
        <div class="container-fluid">
            <div class="view">
                <div class="row">
                    <div class="col-6">
                        <p class="fotoUploader">
                            <strong class="d-block alert alert-info">Formatos permitidos: .jpeg, .png, .jpg, .gif,
                                .pdf,
                                con un peso máximo de 3mb</strong>
                        </p>
                    </div>
                    <div class="col-6">
                        <button type="button" class="formSubmit accordion"
                                v-on:click="accordionPanel('formStationery')">Subir Papelería
                        </button>
                    </div>
                </div>
                <form id="formStationery" class="formStationery row">
                    <input type="hidden" name="supplier_id" :value="supplier_id">
                    <input type="hidden" name="supplier_type" :value="supplier_type">
                    <input type="hidden" name="folder_id" :value="folder_id">
                    <div class="col-12 col-sm-4">
                        <select id="documento" data-select="on" data-name-input="Tipo de Documento" class="required"
                                name="kind_file_stationery_id" v-model="addStationery.kind_file_stationery_id">
                            <option :value="0">Selecciona un documento</option>
                            <option v-for="doc in documents" :value="doc.id" :key="doc.id">{{
                                    doc.name_file
                                }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-4">
                        <div class="fotoUploader">
                    <span class="btn btn-file">
                        Documento <i class="fas fa-upload"></i>
                        <input type="file" class="required"
                               accept="image/*,.pdf" data-label="avatar"
                               name="documento" v-on:change="getLogo"
                               placeholder="Documento">
                    </span>

                        </div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <span class="label-file-papeleria alert alert-info logo"></span>
                    </div>
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </form>
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <h2 class="cabeza">Papelería del cliente</h2>
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="stationeries">
                            <template #cell(tipo)="{item}">
                                {{ item.relkindfile.name_file }}
                            </template>
                            <template #cell(documento)="{item}">
                                <a class="fileName float" v-if="item.archivo" :href="path_storage+item.archivo"
                                   target="_blank">
                                    {{ item.archivo }}
                                </a>
                            </template>
                            <template #cell(fecha_de_carga)="{item}">
                                {{ getHumanDate(item.created_at) }}
                            </template>
                            <template #cell(accion)="{item}">
                                <a class="float badge rounded-pill text-bg-danger" href="javascript:void(0)"
                                   v-on:click="onClickDelete(item.id)">
                                    <i class="fas fa-trash"></i>
                                </a>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {stationeryService} from "../../Services/Stationery.service";
import {kindfilestationeryService} from "../../Services/KindFileStationery.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: 'modalStationery',
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
        folder_id: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            supplier_type: '',
            addStationery: {
                id: '',
                archivo: 0,
                supplier_id: this.supplier_id,
                kind_file_stationery_id: 0,
                supplier_type: ''
            },
            fields: [
                {key: 'tipo'},
                {key: 'documento'},
                {key: 'fecha_de_carga'},
                {key: 'accion'}
            ],
            stationeries: [],
            documents: [],
            selectDocs: {
                limit: 10,
                role_id: this.role_id,
                where: [],
            },
            selectStationeries: {
                where: [],
            },
            tituloBtn: 'Agregar Documento',
            path_storage: '',

        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await stationeryService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formStationery');
            if (respVal) {
                this.disableSubmitBtn(true);
                //DINAMICAMENTE ASIGNAMOS EL VALOR DEL CAMPO A GUARDAR
                const formData = getFormData('formStationery');
                resp = await stationeryService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });
                this.addStationery.archivo = '';
                this.getAlert(resp.process);
                this.setEmpty();
                await this.index();
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },
        async index() {
            let arrayDocs = [];
            this.isBusy = true;
            this.addStationery.supplier_type = this.roleModels[this.folder_id];
            this.supplier_type = this.roleModels[this.folder_id];
            let folder_role = this.storageMapping[Number(this.folder_id)];

            this.selectStationeries.where = [{
                field: 'supplier_id',
                operator: '=',
                value: this.supplier_id,
            }, {
                field: 'supplier_type',
                operator: '=',
                value: 'App\\Models\\' + this.roleModels[this.folder_id],
            }];


            //console.log('folder_role', folder_role, this.folder_id, this.roleModels[this.folder_id]);
            this.path_storage = folder_role + '/papeleria/' + this.supplier_id + '/';
            //arrayDocs = this.buildWhereJson(this.role_id);
            this.documents = await kindfilestationeryService.getMany(this.selectDocs);
            this.stationeries = await stationeryService.getMany(this.selectStationeries);

            this.isBusy = false;
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.addStationery = {
                id: '',
                archivo: '',
                supplier_id: this.supplier_id,
                kind_file_stationery_id: 0,
            };
        }
    },
    mounted() {

        this.index();
    }
}
</script>

<style scoped>
select#documento {
    margin: 0 !important;
}
</style>
